import { Component, OnInit } from "@angular/core";
import { AppService } from "@services/app.service";
import { Subject, takeUntil } from "rxjs";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { EmployeePayRoll } from "@/model/new-joining-form/employee-payroll";
import { printDataService } from "@/model/new-joining-form/printDataService";

@Component({
  selector: "app-new-joining-payroll-table",
  templateUrl: "./new-joining-payroll-table.component.html",
  styleUrls: ["./new-joining-payroll-table.component.scss"]
})
export class NewJoiningPayrollTableComponent implements OnInit {
  searchText: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  datePipe: DatePipe = new DatePipe("en-IN");
  currentDate: string = "";
  userType: string = "";
  listOfPayrollMonths: string[] = [];
  payrollDetails: EmployeePayRoll[] = [];
  reportPayrollDetails: EmployeePayRoll[] = [];
  workingDaysMap: { [key: number]: number } = {};
  leaveDaysMap: { [key: number]: number } = {};
  selectedPayDate: string = "";
  selectMonth: string = "";
  constructor(private appService: AppService, private tostar: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router) {
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd") || null;
  }

  ngOnInit() {
    this.userType = localStorage.getItem('userType');
    this.getAllPayrollMonths();
  }


  getAllPayrollMonths() {
    this.spinner.show();
    this.appService.getAllPayrollMonths()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.listOfPayrollMonths = data;
      }, (err: any) => {
        this.spinner.hide();
        this.tostar.error(err.message || "Something went wrong,")
      })
  }

  getPayrollMonthDetails(event: any) {
    const value = event.target.value;
    this.selectMonth = value;
    this.spinner.show();
    this.appService.getPayrollMonthDetails(value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.selectedPayDate = '';
        this.spinner.hide();
        this.payrollDetails = data.map((employee: any) => {
          employee.bonusAmount = employee.bonusAmount ?? 0;
          employee.deductionAmount = employee.deductionAmount ?? 0;
          if (employee.adminStatus == 'Approved') {
            employee.isUpdated = true;
            employee.otherAllowance = employee?.otherAllowance ?? 0;
          } else {
            employee.otherAllowance = employee.employeeDetails?.otherAllowance ?? 0;
          }
          if (!employee.netPay || employee.netPay === 0) {
            this.calculateNetPay(employee);
          }

          return employee;
        });
      }, (err: any) => {
        this.spinner.hide();
        this.tostar.error(err.message || "Something Went Wrong, Please Try Again");
      });
  }

  //Calculate net pay amount {
  calculateNetPay(employee: any): any {
    const fromDate = new Date(employee.wagesFromDate);
    const toDate = new Date(employee.wagesToDate);
    const totalDays = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    const allowedLeaves = employee?.employeeDetails?.allowedLeaveDays ?? 0;
    const leaveDays = employee.totalLeaves ?? 0;
    const basicPay = employee.basicPay ?? 0;
    const perDaySalary = basicPay / totalDays;

    const minLeavePolicy = employee?.employeeDetails?.minimumLeavePolicy === 'Yes';

    let autoDeduction = 0;
    let bonus = 0;

    if (minLeavePolicy) {
      if (leaveDays <= allowedLeaves) {
        const unusedLeave = allowedLeaves - leaveDays;
        bonus = parseFloat((unusedLeave * perDaySalary).toFixed(2));
      } else {
        const extraLeave = leaveDays - allowedLeaves;
        autoDeduction = parseFloat((extraLeave * perDaySalary).toFixed(2));
      }
    } else {
      autoDeduction = parseFloat((leaveDays * perDaySalary).toFixed(2));
      bonus = 0;
    }

    // Respect manually entered deduction amount
    if (!employee.deductionAmount || employee.deductionAmount === 0) {
      employee.deductionAmount = autoDeduction;
    }

    employee.otherAllowance = employee.otherAllowance ? parseFloat(employee.otherAllowance) : 0;
    employee.bonusAmount = bonus;

    employee.netPay = Math.round(
      (totalDays * perDaySalary) + employee.otherAllowance + employee.bonusAmount - employee.deductionAmount
    ) || 0;

    employee.adminStatus = 'Approved';
    return { ...employee };
  }




  //Update Payroll details
  Update(index: number): void {
    if (this.selectedPayDate == '' || this.selectedPayDate == null) {
      this.tostar.error("Payment days is required")
      return
    } else {
      this.spinner.show();
      const employee = this.payrollDetails[index];
      if (!employee.basicPay || employee.basicPay === 0) {
        employee.basicPay = employee.netPay;
      }
      employee.paymentDate = this.selectedPayDate
      this.appService.updateEmployeePayrollDetails(employee)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response) => {
          this.spinner.hide();
          employee.isUpdated = true;
          this.tostar.success("Payroll details updated successfully!");
        }, (err: any) => {
          this.spinner.hide();
          this.tostar.error(err.message || "Something went wrong, Please try again");
        });
    }
  }


  //Download excel file
  downloadExcel() {
    this.spinner.show();
    if (!this.payrollDetails || this.payrollDetails.length === 0) {
      this.spinner.hide();
      this.tostar.error("No data available to download.");
      return;
    } else {
      console.log(this.payrollDetails)
      const worksheetData = this.payrollDetails.map((report, index) => ({
        'S.No': index + 1,
        'EmployeeId': report?.employeeDetails?.newJoinId || '-',
        'Employee Name': report?.employeeDetails?.employeeName || '-',
        'Phone Number': report?.employeeDetails?.employeeContactNo || '-',
        'Designation': report?.employeeDetails?.designation || '-',
        'Location': report?.employeeDetails?.location || '-',
        'Salary Type': report?.employeeDetails?.salaryType || '-',
        'Account Number': report?.employeeDetails?.accountNo || '-',
        'Bank Name': report?.employeeDetails?.bankName || '-',
        'No Of Working Days': report?.daysWorked || '-',
        "No Of Leave Days": report?.totalLeaves || '-',
        "Basic Salary": report?.basicPay || '-',
        "Per Day Salary": report?.payPerDay || '-',
        "Other Allowance": report?.otherAllowance || '-',
        "Bonus": report?.bonusAmount || '-',
        "Deduction": report?.deductionAmount || '-',
        "Total Salary": report?.netPay || '-',
        "Pay Date": report?.paymentDate || '-',
        "Bank Type": report?.employeeDetails?.bankName === 'Indian Overseas Bank' ? 'AMIOB' : 'AMOTHER',
        "Commands": report?.remarks
      }));

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Filtered Reports');

      const filename = `Varshini Hospital Payroll Details Report, ${new Date().toLocaleDateString()}.xlsx`;
      console.log(worksheetData)
      console.log(this.payrollDetails)
      // Check for issues with Excel file creation
      try {
        XLSX.writeFile(workbook, filename);
        console.log(worksheetData)
        console.log(this.payrollDetails)
        this.spinner.hide();
        this.tostar.success('Excel file downloaded successfully!');
      } catch (error) {
        this.spinner.hide();
        this.tostar.error('Error during file export:', error);
      }
    }
  }


  //Download pdf file
  downloadPDF() {
    const value = this.payrollDetails.map(item => item.wagesMonth);
    this.spinner.show();

    if (!this.payrollDetails || this.payrollDetails.length === 0) {
      this.spinner.hide();
      this.tostar.error("No data available to download.");
      return;
    }

    const doc = new jsPDF('l', 'mm', 'a4');
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.text(`Payroll Details for the Month of ${value[0]}`, 148, 15, { align: 'center' });

    // Define table headers (matching Excel columns)
    const headers = [
      ['S.No', 'Employee ID', 'Employee Name', 'Designation', 'No Of Working Days', 'No Of Leave Days', 'Basic Salary',
        'Other Allowance', 'Bonus', 'Deduction', 'Total Salary']
    ];

    // Function to format number to Indian style (lakhs and crores)
    function formatNumberToIndianStyle(number: number): string {
      return number.toLocaleString('en-IN');
    }

    // Generate table data
    const data = this.payrollDetails.map((report, index) => [
      index + 1,
      report?.employeeDetails?.newJoinId || '-',
      report?.employeeDetails?.employeeName || '-',
      report?.employeeDetails?.designation || '-',
      report?.daysWorked || '-',
      report?.totalLeaves || '-',
      formatNumberToIndianStyle(Number(report?.basicPay)) || '-',
      formatNumberToIndianStyle(Number(report?.otherAllowance)) || '-',
      formatNumberToIndianStyle(Number(report?.bonusAmount)) || '-',
      formatNumberToIndianStyle(Number(report?.deductionAmount)) || '-',
      formatNumberToIndianStyle(Number(report?.netPay)) || '-',
    ]);

    // Add table to PDF
    autoTable(doc, {
      head: headers,
      body: data,
      startY: 25,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 3,
        halign: 'center',
        valign: 'middle',
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [96, 165, 250],
        textColor: [255, 255, 255],
        fontSize: 8,
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0]
      },
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: [0, 0, 0]
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 'auto' },
        4: { cellWidth: 'auto' },
        5: { cellWidth: 'auto' },
        6: { cellWidth: 'auto' },
        7: { cellWidth: 'auto' },
        8: { cellWidth: 'auto' },
        9: { cellWidth: 'auto' },
        10: { cellWidth: 'auto' },
      }
    });

    // Save file with a proper name
    const filename = `Payroll_Report_${new Date().toLocaleDateString().replace(/\//g, '-')}.pdf`;

    try {
      doc.save(filename);
      this.tostar.success('PDF file downloaded successfully!');
    } catch (error) {
      this.tostar.error('Error during PDF export.');
    } finally {
      this.spinner.hide();
    }
  }

}



